export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflowY: 'auto',
  padding: '16px 4px',
  gap: 1,
};

export const emptyStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
  color: 'text.secondary',
};

export const loadMoreStyles = {
  display: 'flex',
  justifyContent: 'center',
  padding: 1,
};

export const dateDividerStyles = {
  position: 'sticky',
  top: 0,
  zIndex: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '4px 0',
  pointerEvents: 'none',
};

export const dateDividerLabelStyles = {
  padding: '2px 10px',
  borderRadius: '999px',
  backgroundColor: ({ palette }) => palette.background.paper,
  border: '1px solid',
  borderColor: 'divider',
  color: ({ palette }) => palette.text.secondary,
  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
};

export const unreadDividerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '6px 16px 4px',
};

export const unreadDividerLineStyles = {
  flex: 1,
  height: '1px',
  backgroundColor: ({ palette }) => palette.error.main,
  opacity: 0.6,
};

export const unreadDividerLabelStyles = {
  padding: '2px 8px',
  borderRadius: '999px',
  backgroundColor: ({ palette }) => palette.error.main,
  color: ({ palette }) => palette.error.contrastText,
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
};
